// src/layouts/ThreeColumnImagesBlock/TwoColumnImagesBlock.js

import React from "react"
import styled from 'styled-components'
import { GatsbyImage } from "gatsby-plugin-image"

const ContentBlock = ({ threeColFirstImage, threeColSecondImage, threeColThirdImage }) => {

  return (
    <BlockContent>
        <div
        data-sal="slide-right"
        data-sal-duration="1000"
        data-sal-delay="300"
        data-sal-easing="ease"
        >
          <GatsbyImage image={threeColFirstImage.localFile.childImageSharp.gatsbyImageData} alt={threeColFirstImage.title} />
        </div>
        <div
        data-sal="slide-up"
        data-sal-duration="1000"
        data-sal-delay="600"
        data-sal-easing="ease"
        >
          <GatsbyImage image={threeColSecondImage.localFile.childImageSharp.gatsbyImageData} alt={threeColSecondImage.title} />
        </div>
        <div
        data-sal="slide-left"
        data-sal-duration="1000"
        data-sal-delay="600"
        data-sal-easing="ease"
        >
          <GatsbyImage image={threeColThirdImage.localFile.childImageSharp.gatsbyImageData} alt={threeColThirdImage.title} />
        </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
    max-width: 1360px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      width: calc(33.33% - 10px);
    }
    @media(max-width:1000px) {
      max-width: 700px;
      flex-wrap: wrap;
      justify-content: center;
      > div {
        width: calc(50% - 10px);
        margin: 5px;
      }
    }
    @media(max-width:767px) {
      max-width: 500px;
      padding: 0;
      margin: 20px auto;
      > div {
        width: 100%;
      }
    }
`

export default ContentBlock